import { getProxiedUrl, getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class BillingService {
    static getPolicyBillingSummary(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'), 'getPolicyBillingSummary', [policyNumber], additionalHeaders);
    }

    // FB 15668 -----
    static getBillingDelivery_RI(authHeader = {}) {
        const params = {
            method: 'GET',
            headers: {
                Authorization: authHeader.Authorization,
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
        };
        return fetch(getProxiedUrl('/ripolicy/pcods/policyholder/policy/billing/billingDelivery'), params).then((response) => response.json())
            .then((response) => {
                return response;
            }).catch((err) => {
                return Promise.reject({
                    error: 'Error with service'
                });
            });
    }

    static updsateBillingDelivery_RI(billinDelivery, authHeader = {}) {
        return fetch(getProxiedUrl('/ripolicy/pcods/policyholder/policy/billing/billingDelivery'), {
            method: 'POST',
            headers: {
                Authorization: authHeader.Authorization,
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify(billinDelivery)
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(`data = ${data}`);
            }).catch((err) => {
                if (_.isEmpty(err)) {
                    return Promise.resolve({
                        error: 'No error!'
                    });
                }
                return Promise.reject({
                    error: 'Error with service'
                });
            });
    }
    // ----- FB 15668
}
